import { PearlApiClient } from 'framework';
import { getAppName } from 'shared/hooks/AppName';

export function ClaimableWebstoresService() {
    const appName = getAppName();
    const api = PearlApiClient(appName);

    const searchClaimableWebstores = async ({
        name,
        categoryName,
        subcategoryName,
        latitude,
        longitude,
        maxDistance,
        size,
    } = {}) => {
        const body = { name };
        if (categoryName) body.categoryName = categoryName;
        if (subcategoryName) body.subcategoryName = subcategoryName;
        if (latitude != null && longitude != null) {
            body.latitude = latitude;
            body.longitude = longitude;
        }
        if (maxDistance != null) body.maxDistance = maxDistance;
        if (size != null) body.size = size;

        const res = await api.post('/api/search/claimable-webstores', body);
        if (res?.ok) return res;
        throw res?.data?.error || res?.data?.message || res;
    };

    return { searchClaimableWebstores };
}
